/**
 * 이미지가 없을 때 대신 세우는 그림.
 *
 * 빈 회색 상자 대신 캐릭터를 두면 "아직 안 왔다"가 아니라 "원래 없다"로 읽힌다 —
 * 목록에서 이미지 없는 항목이 고장처럼 보이지 않는다. 앱 `assets/images` 의 것을 그대로 옮겼다.
 */
export const IMAGE_PLACEHOLDER =
  "/assets/images/placeholder/portfolio_default.webp";

/**
 * 커버(헤더) 자리의 기본 그림. 커버는 화면 폭을 다 쓰는 넓은 자리라 캐릭터 그림을 늘려
 * 놓으면 우스워진다 — 그 자리를 위해 그린 것이 따로 있다.
 */
export const HEADER_IMAGE_PLACEHOLDER =
  "/assets/images/placeholder/header-default.webp";
